var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardLogos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Credit_card_logos",
    "data-name": "Credit card logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 30,
    viewBox: "0 0 246 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 34.798,
    height: 24.058
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 34.798,
    height: 24.058,
    fill: "#262b37"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(-0.5 0.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 54,
    height: 30,
    rx: 3,
    transform: "translate(0.5 -0.098)",
    fill: "#fff",
    opacity: 0.946
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-visa",
    transform: "translate(10.607 9.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M43.853,59.848c-.019,1.459,1.3,2.273,2.293,2.757,1.021.5,1.362.815,1.359,1.259-.008.68-.814.98-1.568.992a5.463,5.463,0,0,1-2.691-.64l-.474,2.219a7.867,7.867,0,0,0,2.914.537c2.752,0,4.553-1.359,4.561-3.464.01-2.672-3.7-2.822-3.673-4.016.008-.362.355-.749,1.113-.848a4.926,4.926,0,0,1,2.584.454l.46-2.147a7.03,7.03,0,0,0-2.451-.45c-2.591,0-4.414,1.378-4.427,3.348m11.3-3.163a1.194,1.194,0,0,0-1.114.742l-3.931,9.386h2.75l.547-1.512h3.36l.318,1.512h2.424L57.4,56.683H55.157m.386,2.739.793,3.8H54.163l1.379-3.8M40.518,56.685,38.35,66.816h2.621l2.166-10.13h-2.62m-3.877,0-2.727,6.9-1.1-5.863A1.222,1.222,0,0,0,31.6,56.685H27.143l-.063.294a10.975,10.975,0,0,1,2.586.861,1.106,1.106,0,0,1,.622.89l2.09,8.083h2.769l4.245-10.13h-2.75",
    transform: "translate(-27.08 -56.5)",
    fill: "#1a2362"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(63.59 0.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    width: 54,
    height: 30,
    rx: 3,
    transform: "translate(0.41 -0.098)",
    fill: "#fff",
    opacity: 0.946
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-mastercard",
    transform: "translate(14.031 4.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M65.915,127.531v-1.366a.8.8,0,0,0-.866-.866.9.9,0,0,0-.774.387.8.8,0,0,0-.729-.387.735.735,0,0,0-.638.318v-.274H62.43v2.187h.479v-1.207c0-.387.2-.57.524-.57s.479.2.479.57v1.207h.479v-1.207a.5.5,0,0,1,.524-.57c.318,0,.479.2.479.57v1.207h.522ZM73,125.344h-.775v-.659h-.479v.659h-.433v.433h.433v1c0,.5.2.8.751.8a1.269,1.269,0,0,0,.592-.159l-.137-.409a.746.746,0,0,1-.409.113c-.228,0-.318-.137-.318-.364v-.979H73v-.433Zm4.053-.046a.645.645,0,0,0-.57.318v-.274H76v2.187h.479V126.3c0-.363.159-.57.455-.57a1.278,1.278,0,0,1,.3.046l.137-.455a1.542,1.542,0,0,0-.318-.022Zm-6.125.228a1.567,1.567,0,0,0-.888-.228c-.546,0-.912.274-.912.705,0,.364.274.57.751.638l.228.022c.25.046.387.113.387.228,0,.159-.183.274-.5.274a1.25,1.25,0,0,1-.729-.228l-.228.364a1.606,1.606,0,0,0,.933.274c.638,0,1-.3,1-.705,0-.387-.3-.592-.751-.659l-.228-.022c-.2-.022-.364-.068-.364-.2,0-.159.159-.25.409-.25a1.623,1.623,0,0,1,.683.183l.206-.389Zm12.7-.228a.645.645,0,0,0-.57.318v-.274H82.58v2.187h.479V126.3c0-.363.159-.57.455-.57a1.278,1.278,0,0,1,.3.046l.137-.455a1.542,1.542,0,0,0-.318-.022Zm-6.1,1.14a1.094,1.094,0,0,0,1.162,1.138,1.134,1.134,0,0,0,.775-.25l-.228-.387a.917.917,0,0,1-.57.2.646.646,0,0,1-.659-.705.671.671,0,0,1,.659-.705.921.921,0,0,1,.57.2l.228-.387a1.131,1.131,0,0,0-.775-.25,1.092,1.092,0,0,0-1.162,1.138Zm4.417,0v-1.092h-.479v.274a.823.823,0,0,0-.683-.318,1.139,1.139,0,0,0,0,2.276.768.768,0,0,0,.683-.318v.274h.479Zm-1.754,0a.661.661,0,1,1,1.319,0,.661.661,0,1,1-1.319,0Zm-5.714-1.14a1.139,1.139,0,0,0,.024,2.276,1.4,1.4,0,0,0,.888-.3l-.228-.342a1.086,1.086,0,0,1-.638.228.614.614,0,0,1-.659-.524H75.48v-.183a1.009,1.009,0,0,0-1-1.16Zm0,.411a.533.533,0,0,1,.546.524H73.885a.574.574,0,0,1,.592-.524Zm11.861.729V124.48h-.479v1.138a.823.823,0,0,0-.683-.318,1.139,1.139,0,0,0,0,2.276.768.768,0,0,0,.683-.318v.274h.479Zm-1.752,0a.661.661,0,1,1,1.319,0,.661.661,0,1,1-1.319,0Zm-15.983,0v-1.092h-.479v.274a.823.823,0,0,0-.683-.318,1.139,1.139,0,0,0,0,2.276.768.768,0,0,0,.683-.318v.274H68.6Zm-1.776,0a.661.661,0,1,1,1.319,0,.661.661,0,1,1-1.319,0Z",
    transform: "translate(-61.089 -106.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1145",
    "data-name": "Rectangle 1145",
    width: 7.171,
    height: 12.887,
    transform: "translate(9.676 1.754)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M65.221,36.946a8.214,8.214,0,0,1,3.12-6.443,8.2,8.2,0,1,0,0,12.885A8.176,8.176,0,0,1,65.221,36.946Z",
    transform: "translate(-55.09 -28.75)",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M141,36.946a8.187,8.187,0,0,1-13.251,6.443,8.212,8.212,0,0,0,0-12.885A8.187,8.187,0,0,1,141,36.946Z",
    transform: "translate(-114.477 -28.75)",
    fill: "#f79e1b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(127.68 0.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1146",
    "data-name": "Rectangle 1146",
    width: 54,
    height: 30,
    rx: 3,
    transform: "translate(0.319 -0.098)",
    fill: "#fff",
    opacity: 0.946
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(8.365 0.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3082",
    d: "M249.14,1546.772v-5.937h6.286l.675.879.7-.879h22.817v5.527a2.635,2.635,0,0,1-1.287.41H265.693l-.76-.936v.936h-2.492v-1.6a2.092,2.092,0,0,1-1.076.223h-.848v1.375h-3.773l-.673-.9-.684.9Z",
    transform: "translate(-241.799 -1525.613)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3080",
    d: "M55.5,1338.927l1.418-3.3h2.451l.8,1.851v-1.851h3.047l.479,1.338.464-1.338h13.68v.673a2.951,2.951,0,0,1,1.9-.673l4.439.015.791,1.827v-1.843h2.55l.7,1.049v-1.049H90.8v5.937H88.226l-.673-1.053v1.053H83.807l-.377-.936H82.422l-.371.936H79.511a2.513,2.513,0,0,1-1.667-.658v.658H74.013l-.76-.936v.936H59.006l-.377-.936h-1l-.374.936H55.5Z",
    transform: "translate(-55.5 -1328.18)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    d: "M57.6,1354.929l-1.912,4.445h1.245l.353-.89h2.051l.351.89h1.272l-1.91-4.445Zm.707,1.035.625,1.556H57.685Z",
    transform: "translate(-55.686 -1346.754)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3048",
    d: "M198.223,1359.354v-4.445l1.769.006,1.029,2.866,1-2.873h1.755v4.445h-1.111v-3.276l-1.178,3.276h-.975l-1.181-3.276v3.276Z",
    transform: "translate(-192.812 -1346.736)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    d: "M364.861,1359.354v-4.445h3.626v.995h-2.5v.76h2.445v.936h-2.445v.79h2.5v.965Z",
    transform: "translate(-353.134 -1346.736)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3052",
    d: "M477.5,1354.929v4.445h1.111v-1.579h.468l1.333,1.579h1.358l-1.462-1.638a1.354,1.354,0,0,0,1.219-1.366,1.438,1.438,0,0,0-1.554-1.442Zm1.111.995h1.27a.51.51,0,0,1,.526.468.5.5,0,0,1-.51.468h-1.287Z",
    transform: "translate(-461.499 -1346.754)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    d: "M596.821,1359.354h-1.135v-4.445h1.135Z",
    transform: "translate(-575.209 -1346.736)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3056",
    d: "M642.041,1359.354H641.8a1.959,1.959,0,0,1-1.9-2.2,2.037,2.037,0,0,1,2.208-2.241h1.228v1.053h-1.273a1.069,1.069,0,0,0-1.037,1.2,1.088,1.088,0,0,0,1.2,1.222h.292Z",
    transform: "translate(-617.738 -1346.736)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3058",
    d: "M711.864,1354.929l-1.912,4.445H711.2l.353-.89H713.6l.351.89h1.272l-1.91-4.445Zm.707,1.035.625,1.556h-1.252Z",
    transform: "translate(-685.142 -1346.754)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3060",
    d: "M852.433,1359.354v-4.445h1.413l1.8,2.793v-2.793h1.111v4.445h-1.367l-1.85-2.866v2.866Z",
    transform: "translate(-822.223 -1346.736)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3062",
    d: "M269.2,1564.567v-4.446h3.626v.994h-2.5v.761h2.445v.936h-2.445v.79h2.5v.965Z",
    transform: "translate(-261.097 -1544.168)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3064",
    d: "M737.946,1564.567v-4.446h3.626v.994h-2.5v.761H741.5v.936H739.07v.79h2.5v.965Z",
    transform: "translate(-712.076 -1544.168)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    d: "M367.507,1564.567l1.766-2.2-1.808-2.25h1.4l1.077,1.391,1.08-1.391h1.345l-1.784,2.223,1.769,2.223h-1.4l-1.045-1.369-1.02,1.369Z",
    transform: "translate(-355.639 -1544.168)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3068",
    d: "M499.869,1560.141v4.446h1.141v-1.4h1.17a1.537,1.537,0,0,0,1.74-1.546,1.463,1.463,0,0,0-1.6-1.5Zm1.141,1.006h1.232a.5.5,0,0,1,.548.512.513.513,0,0,1-.552.512H501.01Z",
    transform: "translate(-483.024 -1544.188)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3072",
    d: "M619.448,1560.121v4.446h1.111v-1.58h.468l1.333,1.58h1.358l-1.462-1.638a1.354,1.354,0,0,0,1.219-1.365,1.438,1.438,0,0,0-1.554-1.442Zm1.111.994h1.27a.51.51,0,0,1,.526.468.5.5,0,0,1-.51.468h-1.287Z",
    transform: "translate(-598.069 -1544.168)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3074",
    d: "M843.606,1564.567v-.965h2.224c.329,0,.472-.178.472-.373s-.142-.376-.472-.376h-1.005a1.243,1.243,0,0,1-1.36-1.331c0-.713.445-1.4,1.744-1.4h2.164l-.468,1h-1.872c-.358,0-.468.188-.468.367a.388.388,0,0,0,.409.387h1.053a1.22,1.22,0,0,1,1.4,1.276,1.333,1.333,0,0,1-1.45,1.415Z",
    transform: "translate(-813.594 -1544.168)",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3076",
    d: "M951.2,1564.567v-.965h2.224c.329,0,.472-.178.472-.373s-.142-.376-.472-.376h-1.005a1.243,1.243,0,0,1-1.36-1.331c0-.713.446-1.4,1.744-1.4h2.164l-.468,1H952.63c-.358,0-.468.188-.468.367a.387.387,0,0,0,.409.387h1.053a1.22,1.22,0,0,1,1.4,1.276,1.333,1.333,0,0,1-1.45,1.415Z",
    transform: "translate(-917.112 -1544.168)",
    fill: "#016fd0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(191.771 0.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1147",
    "data-name": "Rectangle 1147",
    width: 54,
    height: 30,
    rx: 3,
    transform: "translate(0.229 -0.098)",
    fill: "#fff",
    opacity: 0.946
  }), /*#__PURE__*/React.createElement("g", {
    id: "cartes-bancaires-cb-vector-logo",
    transform: "translate(203.13 -23.427)",
    opacity: 0.604
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(-193.3 26.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M211.214,151.945a3.051,3.051,0,0,0-.231-1.162,2.908,2.908,0,0,0-1.723-1.6,5.476,5.476,0,0,0-1.569-.182H198.8v5.89h8.887a5.476,5.476,0,0,0,1.569-.182,2.693,2.693,0,0,0,1.059-.641,2.77,2.77,0,0,0,.664-.956,3.043,3.043,0,0,0,.236-1.167",
    transform: "translate(-179.934 -143.096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M211.214,291.45a3.084,3.084,0,0,0-.231-1.165,2.895,2.895,0,0,0-1.723-1.6,5.318,5.318,0,0,0-1.569-.181H198.8v5.89h8.887a5.485,5.485,0,0,0,1.569-.181,2.707,2.707,0,0,0,1.059-.644,2.739,2.739,0,0,0,.664-.959,2.919,2.919,0,0,0,.236-1.155",
    transform: "translate(-179.934 -275.84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M-105.65,147.408c-.178-3.835-2.935-6.308-7.27-6.308-4.475,0-7.28,2.646-7.28,6.707,0,4.191,2.916,6.707,7.28,6.707s7.1-2.488,7.27-6.322h-7.039V147.4h7.039Z",
    transform: "translate(123.717 -135.576)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLogos);
export default __webpack_public_path__ + "static/media/credit-card-logos.c6fc98e5a1491c60a63022c47484595e.svg";
export { ForwardRef as ReactComponent };